import React from "react"
import { injectIntl } from "react-intl"
import { useSelector } from "react-redux"
import { PricingTableBundleProps } from "../common/types"
import { getBundleItems, getPricingTableItem } from "../state/pricing/selectors"
import PricingTableBundleItem from "./PricingTableBundleItem"
import PricingTableItemComponent from "./PricingTableItemComponent"

const PricingTableBundle = (props: PricingTableBundleProps) => {
    const item = useSelector(state => getPricingTableItem(state, props.itemId, props.objectId))
    const bundleItems = useSelector(state => getBundleItems(state, props.itemId)) || []
    return (
        <>
            <PricingTableItemComponent
                {...props}
            />

            {bundleItems.map(c =>
                <PricingTableBundleItem
                    key={c.id}
                    item={c}
                    objectId={props.objectId}
                    className={props.className}
                    type={props.type}
                    dragHandle={props.dragHandle}
                    allowEdit={props.allowEdit}
                    sortable={props.sortable}
                    mainObjectId={props.mainObjectId}
                    onChange={props.onChange}
                    users={props.users}
                    onEditLinkClick={props.onEditLinkClick}
                    onUpdateCallback={props.onUpdate}
                    assignedToUserId={item?.attributes.assignedToUserId}
                    showInventoryDetails={props.showInventoryDetails}
                />)
            }
        </>
    )
}


export default injectIntl(PricingTableBundle)


// WEBPACK FOOTER //
// ./src/pricing/PricingTableBundle.tsx